/* src/app/components/doc-viewer-new/doc-viewer-action-bar/doc-viewer-action-bar.component.scss */
.main-container {
  color: #fff;
  background: rgb(36, 62, 144);
}
:host-context(.dark-theme) .main-container {
  color: white;
  background: #2E2E2E;
  box-shadow: inset 1px 0px 1px 1px rgba(0, 0, 0, 0.26);
}
.view-items {
  background: rgb(36, 62, 144);
  color: #fff;
  display: flex;
}
#actions > div {
  background: rgb(36, 62, 144);
}
:host-context(.dark-theme) .view-items {
  background: #333333;
}
:host-context(.dark-theme) #actions > div {
  background: #484848;
}
.view {
  display: flex;
  flex-direction: row;
  gap: 7px;
  align-items: center;
  justify-content: center;
  height: 100%;
  border-radius: 0;
  cursor: pointer;
  padding: 0 20px;
}
.view,
.view-menu {
  border-left: 1px solid rgba(255, 255, 255, 0.15);
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.view-menu {
  border-right: 1px solid rgba(255, 255, 255, 0.15);
}
:host-context(.dark-theme) .view,
:host-context(.dark-theme) .view-menu {
  border-left: 1px solid #484848;
  border-right: 1px solid transparent;
}
.icon {
  --fa-primary-color: #d4daee;
  --fa-secondary-color: rgb(83 105 175);
  --fa-secondary-opacity: 1;
  font-size: 20px;
  width: 23px;
  transition: transform 0.2s;
}
.icon:hover {
  transform: scale(1.1);
}
:host-context(.dark-theme) .icon {
  --fa-primary-color: #FFC107;
  --fa-secondary-color: #454545;
}
.selected-view {
  background-color: rgb(32, 54, 126) !important;
}
:host-context(.dark-theme) .selected-view {
  background-color: rgba(0, 0, 0, 0.87) !important;
}
.disabled-view {
  cursor: default !important;
  border: inherit !important;
  box-shadow: inherit !important;
}
.disabled-icon {
  --fa-primary-color: rgb(117 134 188);
  --fa-secondary-color: rgb(65 87 156);
  --fa-secondary-opacity: 1;
  font-size: 20px;
}
.disabled-text {
  color: rgb(115, 132, 185);
}
:host-context(.dark-theme) .disabled-icon {
  --fa-primary-color: #6e6e6e;
  --fa-secondary-color: #b0b0b04d;
  --fa-secondary-opacity: 1;
  font-size: 20px;
}
:host-context(.dark-theme) .disabled-text {
  color: #6e6e6e;
}
.action-button {
  width: 55px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  background-color: inherit;
  color: inherit;
  font-size: 14px;
  border: inherit;
  border-left: rgba(237, 237, 237, 0.2392156863) 1px solid;
  width: 55px;
}
:host-context(.dark-theme) .action-button:hover {
  border: 1px solid #FFC107;
  box-shadow: 0px 0px 1px 2px rgba(255, 193, 7, 0.4117647059);
}
.button-icon {
  --fa-primary-color: #fff;
  --fa-secondary-color: rgb(36, 62, 144);
  --fa-secondary-opacity: 0.4;
  font-size: 20px;
}
:host-context(.dark-theme) .button-icon {
  --fa-primary-color: #737373;
  --fa-secondary-color: #FFC107;
  --fa-secondary-opacity: 1 ;
}
.case-logo-area {
  background: rgb(36, 62, 144);
  color: #fff;
  box-shadow: 1px 0px 1px 1px rgba(0, 0, 0, 0.1);
}
:host-context(.dark-theme) .case-logo-area {
  background: #2E2E2E;
}
.logo-wrapper {
  background: #f5f5f5;
  height: 100%;
  padding-bottom: 4px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  border-radius: 0 10px 0 0;
}
.lexbe-toolbar-logo {
  height: 34px;
}
:host-context(.dark-theme) .logo-wrapper {
  background: #000;
}
.close-button {
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}
:host-context(.dark-theme) .close-button {
  border-left: 1px solid #585858;
}
.action-button-icon {
  --fa-primary-color: #fff;
  --fa-secondary-color: #7c8bbc;
  --fa-secondary-opacity: 1;
  font-size: 20px;
}
:host-context(.dark-theme) .action-button-icon {
  --fa-primary-color: #737373;
  --fa-secondary-color: #FFC107;
  --fa-secondary-opacity: 1;
}
.tab-menu-icon {
  color: #d4daee;
}
:host-context(.dark-theme) .tab-menu-icon {
  color: #FFC107;
}
::ng-deep .doc-viewer-menu.action-bar-view-menu {
  width: 242px;
}
::ng-deep .doc-viewer-menu.action-bar-view-menu .mat-mdc-menu-item {
  color: #363636;
}
::ng-deep .doc-viewer-menu.action-bar-view-menu .mat-mdc-menu-item:hover:not([disabled]) {
  background: rgba(36, 62, 144, 0.15);
}
::ng-deep .doc-viewer-menu.action-bar-view-menu .icon {
  --fa-primary-color: rgb(36, 62, 144);
  --fa-secondary-color: #a6b1d2;
  --fa-secondary-opacity: 1;
  font-size: 20px;
}
::ng-deep .doc-viewer-menu.action-bar-view-menu .disabled-icon {
  --fa-primary-color: #929292;
  --fa-secondary-color: #c8c8c8;
  --fa-secondary-opacity: 1;
  font-size: 20px;
}
::ng-deep .doc-viewer-menu.action-bar-view-menu .disabled-text {
  color: rgba(0, 0, 0, 0.4);
}
::ng-deep .dark-theme .doc-viewer-menu.action-bar-view-menu {
  background: #000 !important;
}
::ng-deep .dark-theme .doc-viewer-menu.action-bar-view-menu .mat-mdc-menu-item {
  color: #fff;
}
::ng-deep .dark-theme .doc-viewer-menu.action-bar-view-menu .mat-mdc-menu-item:hover:not([disabled]) {
  background: rgba(255, 193, 7, 0.55);
}
::ng-deep .dark-theme .doc-viewer-menu.action-bar-view-menu .icon {
  --fa-primary-color: #FFC107;
  --fa-secondary-color: #373636;
}
::ng-deep .dark-theme .doc-viewer-menu.action-bar-view-menu .disabled-icon {
  --fa-primary-color: #6e6e6e;
  --fa-secondary-color: #b0b0b04d;
  --fa-secondary-opacity: 1;
  font-size: 20px;
}
::ng-deep .dark-theme .doc-viewer-menu.action-bar-view-menu .disabled-text {
  color: rgba(255, 255, 255, 0.4);
}
::ng-deep .doc-viewer-menu.action-bar-view-menu::-webkit-scrollbar {
  height: 8px;
  width: 15px;
}
::ng-deep .doc-viewer-menu.action-bar-view-menu::-webkit-scrollbar-thumb {
  -webkit-border-radius: 6px;
  background: rgb(36, 62, 144);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  background-clip: padding-box;
}
::ng-deep .doc-viewer-menu.action-bar-view-menu::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  background-clip: padding-box;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}
::ng-deep .dark-theme .doc-viewer-menu.action-bar-view-menu::-webkit-scrollbar-thumb {
  background: #ffc107;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  background-clip: padding-box;
}
::ng-deep .dark-theme .doc-viewer-menu.action-bar-view-menu::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}
::ng-deep .dark-theme .doc-viewer-menu.action-bar-view-menu::-webkit-scrollbar-corner {
  background: #000;
}
.action-item {
  display: none;
  cursor: pointer;
  margin-right: 16px;
  margin-left: 16px;
}
.action-icon {
  --fa-primary-color: #fff;
  --fa-secondary-color: #7c8bbc;
  --fa-secondary-opacity: 1;
}
:host-context(.dark-theme) .action-icon {
  --fa-primary-color: #737373;
  --fa-secondary-color: #FFC107;
  --fa-secondary-opacity: 1;
}
.title-container:hover .action-item {
  display: flex;
  flex-direction: row;
}
/*# sourceMappingURL=doc-viewer-action-bar.component.css.map */
